/** Who may hold the contracts & invoicing grant, as on-screen text names them. */
export const BACK_OFFICE_HOLDERS =
  'the practice owner, or an admin or practitioner with the contracts & invoicing grant';
